import createComponent from '../create-component';
export default createComponent([["title",{"key":"svg-title"}],["circle",{"cx":"48","cy":"48","r":"48","mask":"url(#looks-mono_svg__a)","key":"svg-circle"}],["defs",{"key":"svg-defs"}]]);